import React, {
  useRef,
  useEffect,
  useState,
  useContext,
  useCallback,
} from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { DialogFaltasSeguidas } from "./DialogFaltasSeguidas";
import "../layout/sass/_responsiveTable.scss";

import "../layout/sass/_dashboard.scss";

import { AuthContext } from "../contexts/AuthContext";

import api from "../api/api";

import FullCalendarApp from "./FullCalendarApp";

export const DashBoard = () => {
  const toast = useRef(null);
  const [showFaltasSeguidas, setShowFaltasSeguidas] = useState(false);
  const [faltasSeguidas, setFaltasSeguidas] = useState([]);
  const [countFaltasSeguidas, setCountFaltasSeguidas] = useState(0);
  const { user } = useContext(AuthContext);

  const getFaltasSeguidas = useCallback(async () => {
    try {
      const response = await api.get(`falta/faltasSeguidas`);
      setFaltasSeguidas(response.data);
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Erro ao obter alunos",
        detail: error.toString(),
      });
    }
  }, []);

  useEffect(() => {
    async function dashboard() {
      await getFaltasSeguidas();
    }
    dashboard();
  }, [getFaltasSeguidas]);

  return (
    <>
      <Toast ref={toast} position="bottom-right" />

      {
        <>
          <div className="p-grid p-fluid">
            {user.perfilUser[0] !== "user-instrutor" ? (
              <>
                <div className="p-col-12 p-md-4 p-xl-4">
                  <div className="p-d-flex counter-container">
                    <div
                      className="counter-label-container"
                      style={
                        countFaltasSeguidas > 0
                          ? { backgroundColor: "red", color: "#fff" }
                          : { backgroundColor: "#1d8ef0", color: "#fff" }
                      }
                    >
                      <span>Faltas seguidas</span>
                    </div>
                    <div
                      className="counter-value-container p-p-1"
                      style={{ backgroundColor: "#fff", color: "#858585" }}
                    >
                      <span
                        className="count-label"
                        style={
                          countFaltasSeguidas > 0
                            ? { fontWeight: "bold", color: "red" }
                            : {}
                        }
                      >
                        <i className="pi pi-calendar"></i> Total
                      </span>
                      <span
                        className="count"
                        style={
                          countFaltasSeguidas > 0
                            ? { fontWeight: "bold", color: "red" }
                            : {}
                        }
                      >
                        {countFaltasSeguidas}
                      </span>
                      {showFaltasSeguidas ? (
                        <DialogFaltasSeguidas
                          visible={showFaltasSeguidas}
                          setVisible={setShowFaltasSeguidas}
                          faltas={faltasSeguidas}
                        />
                      ) : (
                        ""
                      )}
                      <Button
                        icon="pi pi-info"
                        className="p-button-rounded p-button-secondary"
                        onClick={() => setShowFaltasSeguidas(true)}
                        tooltip="Relatório de alunos com faltas seguidas"
                        tooltipOptions={{ position: "top" }}
                        style={{
                          left: "5px",
                          bottom: "5px",
                          height: "20px",
                          width: "15px",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="p-col-12 p-md-12 p-xl-12" height="100">
                  <FullCalendarApp />
                </div>
              </>
            ) : (
              <div className="p-col-12 p-md-12 p-xl-12" height="100">
                <FullCalendarApp />
              </div>
            )}
          </div>
          {/* Total de Matriculas */}
          {user.perfilUser[0] !== "user-instrutor" ? (
            <>
              <div style={{ paddingTop: "10px", paddingBottom: "10px" }}></div>
              <div className="counter-value-container p-p-1">
                <iframe
                  src="https://metabase.app.patosdeminas.mg.gov.br/public/dashboard/fdb54a40-01ee-4d40-9c67-1de6efb84019"
                  frameborder="0"
                  width="1610"
                  height="600"
                  allowtransparency
                  title="Total de Matriculas"
                />
                {/* Total de Tipo de Curso */}
                <div
                  style={{ paddingTop: "10px", paddingBottom: "10px" }}
                ></div>
                <div className="counter-value-container p-p-1">
                  <iframe
                    src="https://metabase.app.patosdeminas.mg.gov.br/public/dashboard/e1018435-a45e-4184-b25b-9e6092776990"
                    frameborder="0"
                    width="1620"
                    height="600"
                    allowtransparency
                    title="Total de Tipo de Curso"
                  />
                </div>
                {/* Lista de Espera por instrumento */}
                <div
                  style={{ paddingTop: "10px", paddingBottom: "10px" }}
                ></div>
                <div className="counter-value-container p-p-1">
                  <iframe
                    src="https://metabase.app.patosdeminas.mg.gov.br/public/question/42b87fe7-fa24-4c01-adc8-c744c8e5ccf9"
                    frameborder="0"
                    width="1600"
                    height="600"
                    allowtransparency
                    title="Lista de Espera por Instrumento"
                  />
                </div>
                <div
                  style={{ paddingTop: "10px", paddingBottom: "10px" }}
                ></div>
                <div className="counter-value-container p-p-1">
                  <iframe
                    src="https://metabase.app.patosdeminas.mg.gov.br/public/dashboard/c9119c88-3ac3-4e91-965c-517657f66aef"
                    frameborder="0"
                    width="1600"
                    height="600"
                    allowtransparency
                    title="Tarefas por Turma"
                  />
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      }
    </>
  );
};
